import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid2 as Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material'
import Paper from 'components/@extended/Paper'
import type { FC } from 'react'
import type { ApprovalChain } from 'types/approvals'
import type { OrganizationSettingDTO } from 'types/organization'

interface ApprovalSettingsProps {
  settings: OrganizationSettingDTO[]
  handleChange: (keyOrIndex: string | number, value: string) => void
  approvalChains: ApprovalChain[] | undefined
}

const ApprovalSettings: FC<ApprovalSettingsProps> = ({ settings, handleChange, approvalChains }) => {
  const theme = useTheme()

  return (
    <Paper elevation={0}>
      <Typography variant="h5" gutterBottom mb={2}>
        Approval Settings
      </Typography>
      <Grid container spacing={3} p={2}>
        {/* Approval Chains Section */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="h6" gutterBottom mb={2}>
            Approval Chains
          </Typography>
        </Grid>
        {['Metric', 'Accrual', 'Target', 'Plan', 'Accrual Ledger'].map((type) => (
          <Grid size={{ xs: 12, sm: 6 }} key={type}>
            <FormControl
              fullWidth
              variant="outlined"
              sx={{
                '& .MuiInputLabel-root': {
                  backgroundColor: theme.palette.background.paper,
                },
              }}
            >
              <InputLabel shrink variant="outlined">
                {`${type} Approval Chain`}
              </InputLabel>
              <Select
                fullWidth
                label={`${type} Approval Chain`}
                variant="outlined"
                value={settings.find((s) => s.settingName === `${type} Approval Chain`)?.settingValue || ''}
                onChange={(e) => handleChange(`${type.toLowerCase().replace(' ', '-')}-approval-chain`, e.target.value)}
                style={{ borderRadius: '21px' }}
              >
                {approvalChains && approvalChains.length > 0 ? (
                  approvalChains.map((chain) => (
                    <MenuItem key={chain.id} value={chain.id?.toString() ?? ''}>
                      {chain.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No approval chains available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        ))}

        {/* Auto Approve Visibility Section */}
        <Grid size={{ xs: 12 }}></Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  settings.find((s) => s.settingKey === 'auto-approve-progress-visibility')?.settingValue === 'true'
                }
                onChange={(e) => handleChange('auto-approve-progress-visibility', e.target.checked ? 'true' : 'false')}
              />
            }
            label="Auto Approve Progress Visibility"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ px: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  settings.find((s) => s.settingKey === 'auto-approve-actuals-visibility')?.settingValue === 'true'
                }
                onChange={(e) => handleChange('auto-approve-actuals-visibility', e.target.checked ? 'true' : 'false')}
              />
            }
            label="Auto Approve Actuals Visibility"
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default ApprovalSettings
